import React, { useState } from "react";
import { Icon } from "components/atoms/icon";
import classNames from "classnames";

import styles from "./EventMobileFilters.module.scss";
import {
  EventCategoryItemFragment,
  IndustryItemFragment,
} from "../../generated/graphql";
import { UseFormReturn } from "../../form";
import { ListEventsFilterForm } from "./PageListEvents";
import {
  MobileFilterItem,
  MobileFiltersPanel,
} from "../../components/molecules/mobileFiltersPanel";
import { TextInput } from "../../components/molecules/textInput";
import { DropDown, withNullOption } from "../../components/molecules/dropDown";
import { areasDropDownOptions } from "../../common";
import { CalendarInput } from "../../components/molecules/calendar";
import { MultiSelect } from "../../components/molecules/multiselect";
import { CheckBoxGroup } from "../../components/molecules/checkBoxGroup";
import { Button } from "../../components/atoms/button";
import { DateRangeComponent } from "../../components/molecules/dateRange";

interface Props {
  clearFields: () => void;
  onSubmit: () => void;
  industries: IndustryItemFragment[];
  form: UseFormReturn<ListEventsFilterForm>;
  eventCategories: Array<EventCategoryItemFragment>;
}

export default function EventMobileFilters(props: Props) {
  const { clearFields, onSubmit, industries, form, eventCategories } = props;
  const [isOpen, setIsOpen] = useState(false);
  const { field } = form;

  return (
    <>
      <MobileFiltersPanel
        openMode={isOpen ? "opened" : "closed"}
        onToggleRequest={() => setIsOpen(!isOpen)}
      >
        <div className={styles.filtersContainer}>
          <MobileFilterItem hasBorder className={styles.textSearch}>
            <TextInput
              {...field("title")}
              headless={true}
              label="イベント名・企業名"
            />
            <Icon name="search" size="large" />
          </MobileFilterItem>
          <MobileFilterItem hasBorder>
            <CalendarInput
              allowPast
              label={
                <div
                  className={classNames(styles.dateLabel, {
                    [styles.isPlaceholder]:
                      !field("endDate").value && !field("startDate").value,
                  })}
                >
                  <DateRangeComponent
                    endDate={field("endDate").value}
                    fallback="開催期間"
                    startDate={field("startDate").value}
                  />
                </div>
              }
              noClear
              onChange={({ endDate, startDate }) => {
                field("endDate").setValue(endDate);
                field("startDate").setValue(startDate);
              }}
              value={{
                endDate: field("endDate").value,
                startDate: field("startDate").value,
              }}
            />
          </MobileFilterItem>
          <MobileFilterItem hasBorder>
            <DropDown
              headless
              {...withNullOption(areasDropDownOptions, "エリア（全て）")}
              {...field("area")}
              type="arrange"
            />
          </MobileFilterItem>
          <MobileFilterItem hasBorder>
            <MultiSelect
              label="業界"
              options={industries}
              {...field("industries")}
              toKey={(i) => i.id}
              renderLabel={(i) => i.name}
              type="medium"
              headless
            />
          </MobileFilterItem>
          <MobileFilterItem>
            <div className={styles.categoryFilter}>
              <p>イベント種別</p>
              <CheckBoxGroup
                className={styles.categoryCheckboxGroup}
                checkboxClassName={styles.categoryCheckbox}
                labelClassName={styles.categoryCheckboxLabel}
                checkedClassName={styles.categoryCheckboxChecked}
                options={eventCategories.sort(
                  (c1, c2) => c1.displayOrder - c2.displayOrder,
                )}
                {...field("eventCategories")}
                renderLabel={(c) => c.name}
                toKey={(c) => c.id}
              />
            </div>
          </MobileFilterItem>
        </div>
        <div className={styles.actionContainer}>
          <Button
            className={styles.clearFields}
            size="midSmall"
            color="secondary"
            onClick={clearFields}
          >
            クリア
          </Button>
          <Button size="midSmall" onClick={onSubmit}>
            絞り込む
          </Button>
        </div>
      </MobileFiltersPanel>
    </>
  );
}
